import { TransformedLocaleConfig, LocaleName } from '../type';
const baseLocaleConfig = {
  name: 'ms',
  months: [
    'Januari',
    'Februari',
    'Mac',
    'April',
    'Mei',
    'Jun',
    'Julai',
    'Ogos',
    'September',
    'Oktober',
    'November',
    'Disember',
  ],
  monthsShort: ['Jan', 'Feb', 'Mac', 'Apr', 'Mei', 'Jun', 'Jul', 'Ogos', 'Sep', 'Okt', 'Nov', 'Dis'],
  weekdays: ['Ahad', 'Isnin', 'Selasa', 'Rabu', 'Khamis', 'Jumaat', 'Sabtu'],
  weekdaysMin: ['A', 'I', 'S', 'R', 'K', 'J', 'S'],
  weekdaysShort: ['Aha', 'Isn', 'Sel', 'Rab', 'Kha', 'Jum', 'Sab'],
  formats: {
    LT: 'HH:mm',
    LTS: 'HH:mm:ss',
    lt: 'h:mm A',
    lts: 'h:mm:ss A',
    L: 'D/M/YYYY',
    LL: 'D MMMM YYYY',
    'LL-D': 'MMMM YYYY',
    'LL-Y': 'D MMMM',
    LLL: 'D MMMM YYYY HH:mm',
    'LLL-Y': 'D MMMM HH:mm',
    LLLL: 'dddd, D MMMM YYYY, HH:mm',
    'LLLL-Y': 'dddd D MMMM HH:mm',
    l: 'D/M/YYYY',
    'l-Y': 'D/M',
    ll: 'D MMM YYYY',
    'll-Y': 'D MMM',
    'll-D': 'MMM YYYY',
    lll: 'D MMM YYYY, h:mm A',
    'lll-Y': 'D MMM h:mm A',
    llll: 'ddd, D MMM YYYY, h:mm A',
    'llll-Y': 'ddd, D MMM h:mm A',
    'll-Y+w': 'ddd, D MMM',
    'LT+to': 'HH:mm ([GMT]Z)',
    'LLL+to': 'D MMMM YYYY HH:mm ([GMT]Z)',
  },
  meridiem: { am: 'pg', pm: 'ptg', AM: 'PG', PM: 'PTG' },
  past: {
    y: { other: '%s thn lalu' },
    M: { other: '%s bln lalu' },
    w: { other: '%s mgu lalu' },
    d: { other: '%s hari lalu' },
    h: { other: '%s jam lalu' },
    m: { other: '%s min lalu' },
    s: { other: '%s saat lalu' },
  },
  future: {
    y: { other: 'dalam %s thn' },
    M: { other: 'dlm %s bln' },
    w: { other: 'dlm %s mgu' },
    d: { other: 'dlm %s hari' },
    h: { other: 'dlm %s jam' },
    m: { other: 'dlm %s min' },
    s: { other: 'dlm %s saat' },
  },
  pastLong: {
    y: { other: '%s tahun lalu' },
    M: { other: '%s bulan lalu' },
    w: { other: '%s minggu lalu' },
    d: { other: '%s hari lalu' },
    h: { other: '%s jam lalu' },
    m: { other: '%s minit lalu' },
    s: { other: '%s saat lalu' },
  },
  futureLong: {
    y: { other: 'dalam %s tahun' },
    M: { other: 'dalam %s bulan' },
    w: { other: 'dalam %s minggu' },
    d: { other: 'dalam %s hari' },
    h: { other: 'dalam %s jam' },
    m: { other: 'dalam %s minit' },
    s: { other: 'dalam %s saat' },
  },
  abbr: {
    y: { other: '%sthn' },
    M: { other: '%sb' },
    w: { other: '%sm' },
    d: { other: '%sh' },
    h: { other: '%sj' },
    m: { other: '%smin' },
    s: { other: '%ss' },
  },
  full: {
    y: { other: '%s tahun' },
    M: { other: '%s bulan' },
    w: { other: '%s minggu' },
    d: { other: '%s hari' },
    h: { other: '%s jam' },
    m: { other: '%s minit' },
    s: { other: '%s saat' },
  },
  justNow: 'Baru sahaja',
  yesterday: 'Semalam',
  today: 'Hari Ini',
  tomorrow: 'Esok',
  weekStart: 1,
  timeRange: '%$1s – %$2s',
  timeZone: '%$1s %$2s',
  timePref: { 'HH:mm': 'h:mm A' },
  timeRangeStyles: {
    yl: { start: 'D MMMM YYYY', end: 'D MMMM YYYY' },
    'yl-1': { start: 'D MMMM', end: 'D MMMM YYYY' },
    ml: { start: 'D MMMM', end: 'D MMMM' },
    'ml-1': { start: 'D', end: 'D MMMM YYYY' },
    dl: { start: 'D', end: 'D MMMM' },
    y: { start: 'D MMM YYYY', end: 'D MMM YYYY' },
    'y-1': { start: 'D MMM', end: 'D MMM, YYYY' },
    m: { start: 'D MMM', end: 'D MMM' },
    'm-1': { start: 'D', end: 'D MMM YYYY' },
    d: { start: 'D', end: 'D MMM' },
    Y: { start: 'ddd, D MMM YYYY', end: 'ddd, D MMM YYYY' },
    'Y-1': { start: 'ddd, D MMM', end: 'ddd, D MMM YYYY' },
    M: { start: 'ddd, D MMM', end: 'ddd, D MMM' },
    D: { start: 'ddd, D MMM', end: 'ddd, D MMM' },
    yt: { start: 'D MMM YYYY HH:mm', end: 'D MMM YYYY HH:mm' },
    mt: { start: 'D MMM HH:mm', end: 'D MMM HH:mm' },
    dt: { start: 'D MMM HH:mm', end: 'D MMM HH:mm' },
    t: { start: 'HH:mm', end: 'HH:mm' },
    'yt+to': { start: 'D MMM YYYY HH:mm', end: 'D MMM YYYY HH:mm ([GMT]Z)' },
    'mt+to': { start: 'D MMM HH:mm', end: 'D MMM HH:mm ([GMT]Z)' },
    'dt+to': { start: 'D MMM HH:mm', end: 'D MMM HH:mm ([GMT]Z)' },
    't+to': { start: 'HH:mm', end: 'HH:mm ([GMT]Z)' },
  },
};
const localeName: LocaleName = 'ms';
export const localeConfig: TransformedLocaleConfig = {
  ...baseLocaleConfig,
  name: localeName,
  ordinal: (n) => `${n}.`,
  meridiem: (hour, _, isLowerCase = false): string => {
    if (hour < 12) {
      return isLowerCase ? 'pg' : 'PG';
    } else {
      return isLowerCase ? 'ptg' : 'PTG';
    }
  },
};
